export default function WaitingRoom({ session }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: 'calc(100vh - 64px)',
      textAlign: 'center',
      padding: '40px',
    }}>
      <div style={{
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        backgroundColor: '#0070CC',
        marginBottom: '20px',
        animation: 'pulse 2s ease-in-out infinite',
      }} />
      <h1 style={{ fontSize: '24px', fontWeight: 600, color: '#333', marginBottom: '12px' }}>
        Waiting for Instructor to Start Session
      </h1>
      <p style={{ fontSize: '16px', color: '#6b7280', maxWidth: '400px', lineHeight: 1.6 }}>
        Your session will begin shortly. Please wait for your instructor to start.
      </p>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.4; transform: scale(1.3); }
        }
      `}</style>
    </div>
  )
}